import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M10.3953 3.55413C10.0776 3.24546 9.57212 3.24518 9.2541 3.55351L6 6.7085L2.7459 3.55351C2.42788 3.24518 1.92239 3.24546 1.60471 3.55413C1.27358 3.87587 1.27358 4.40753 1.60471 4.72927L6 9L10.3953 4.72927C10.7264 4.40753 10.7264 3.87587 10.3953 3.55413Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgArrowDown);
export default ForwardRef;
